import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import style from './cost-review-line-item-applied-recommendation.module.less';
import { messages } from './messages';
import FormattedCurrency from '../../formatted-currency';

/**
 * @param {object} props
 * @param {import('../../../prop-types/cost-review.types').CostReviewRecommendation} props.recommendation
 * @param {boolean} props.isToggleRecommendationDisabled
 * @param {(recommendationKey: string) => void} props.onToggleRecommendation
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemAppliedRecommendation = ({ recommendation, isToggleRecommendationDisabled, onToggleRecommendation }) => {
  return (
    <div className={style['applied-savings-container']}>
      <div className={style['applied-savings']}>
        <FontAwesomeIcon className={style['applied-savings-icon']} icon={faCheckCircle} />
        <Text
          formattedMessageValues={{
            savingsAmount: <FormattedCurrency currencyCode={recommendation.totalSavings.code} value={recommendation.totalSavings.value} />,
            b: (chunks) => <b>{chunks}</b>,
          }}
          textType={TextType.Caption}
          value={messages.appliedSavings}
        />
      </div>
      <Button className={style['undo-button']} disabled={isToggleRecommendationDisabled} onClick={onToggleRecommendation} theme='link'>
        <FormattedMessage {...messages.undo} />
      </Button>
    </div>
  );
};
